import useViewportSpy from 'beautiful-react-hooks/useViewportSpy';
import clsx from 'clsx';
import { memo, useEffect, useRef } from 'react';

import { useVideoPlaylist } from '../../hooks/videos';
import { useVideoPlaylistOptions } from '../../store';
import VideoCard from '../VideoCard';

import { useWindowSize } from '@hooks/useWindowSize';
import Bouncer from '@shared/Bouncer';

import * as classes from './styles.module.scss';

const VideoList = () => {
  const containerRef = useRef(null);
  const scrollSpyRef = useRef(null);
  const { isDesktop, isLandscape } = useWindowSize();
  const scrolled = useViewportSpy(scrollSpyRef);
  const { options } = useVideoPlaylistOptions();
  const { videos, hasNextPage, fetchNextPage } = useVideoPlaylist();

  useEffect(() => {
    if (!options.infiniteScroll || !scrolled) return;

    fetchNextPage();
  }, [fetchNextPage, options, scrolled]);

  return (
    <div pk-theme={isDesktop || isLandscape ? 'dark' : null} ref={containerRef} className={classes.container}>
      <div className={clsx('pk-d--flex pk-flex--column', classes.list)} role='list'>
        {videos.map((video) => (
          <VideoCard key={video.id} video={video} />
        ))}
        <div className={clsx(classes.scrollSpy, !videos.length && 'pk-d--none')} ref={scrollSpyRef} />
        {hasNextPage && <Bouncer />}
      </div>
    </div>
  );
};

export default memo(VideoList);
